import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { paymentMethodsReducer } from '../../reducers/paymentMethods';
import { IApplicationState, IThunkContext } from '../../types/redux';
import { TReduxActions } from '../../types/actions';
import { checkoutReducer } from '../../reducers/checkout';
import { layoutReducer } from '../../reducers/layout';
import { composeWithDevTools } from '@redux-devtools/extension';

export const createReduxStore = (context: IThunkContext) => {
  const { config } = context;

  const reducers = combineReducers<IApplicationState, TReduxActions>({
    paymentMethods: paymentMethodsReducer,
    checkout: checkoutReducer,
    layout: layoutReducer,
  });

  const reduxDevToolsName = `Payment widget · ${config.get('mcsRunEnv')} · ${config.get('version.commit')}`;

  const composeEnhancers = composeWithDevTools({ name: reduxDevToolsName });

  const storeEnhancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  return createStore(reducers, storeEnhancers);
};
